import React, { useRef, useEffect } from "react";
import {
  BarChart3,
  User,
  CreditCard,
  Settings,
  Lock,
  HelpCircle,
} from "lucide-react";
import { useDispatch } from "react-redux";
import { useTranslation } from "../../../../contexts/I18nProvider";
import { useTheme } from "../../../../contexts/ThemeContext";
import { setActiveSection } from "../../../../redux/slices/profileSlice";
import styles from "./MobileTabNav.module.css";

const MobileTabNav = ({ activeSection }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const scrollContainerRef = useRef(null);
  const activeTabRef = useRef(null);

  const tabs = [
    { id: "overview", icon: BarChart3, label: t("pages.profile.sections.overview") },
    { id: "account", icon: User, label: t("pages.profile.sections.account") },
    {
      id: "subscription",
      icon: CreditCard,
      label: t("pages.profile.sections.subscription"),
    },
    { id: "preferences", icon: Settings, label: t("pages.profile.sections.preferences") },
    { id: "security", icon: Lock, label: t("pages.profile.sections.security") },
    { id: "help", icon: HelpCircle, label: t("pages.profile.sections.help") },
  ];

  const handleTabClick = (tabId) => {
    dispatch(setActiveSection(tabId));
  };

  // Scroll active tab into view
  useEffect(() => {
    if (activeTabRef.current && scrollContainerRef.current) {
      activeTabRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [activeSection]);

  return (
    <nav className={`${styles.tabNav} ${isDark ? styles.dark : ""}`}>
      <div className={styles.scrollContainer} ref={scrollContainerRef}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeSection === tab.id;

          return (
            <button
              ref={isActive ? activeTabRef : null}
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`${styles.tab} ${isActive ? styles.active : ""}`}
              aria-current={isActive ? "page" : undefined}
              role="tab"
              aria-selected={isActive}
            >
              <Icon size={20} className={styles.icon} />
              <span className={styles.label}>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTabNav;
